// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8bcc2ff2","229":"3d5ff421","290":"66f605a9","381":"b07dff2a","842":"0e7d11c3","851":"e3491ccd","924":"7155c5c9","974":"736b35ea"}[chunkId] + ".chunk.js";
};